import { outsideClick } from './outsideClick';

export { outsideClick };

export default {
    install (app) {
        app.directive('outside-click', outsideClick);
    },
};
